module.exports = __webpack_public_path__ + "images/playstore_blackwhite_46248160245a64535f2ba08b893ed5aa.png";